import { getCommercialIncomeTitle } from './getCommercialIncomeTitle';
import { getCommercialPerMeterByYear } from './getCommercialPerMeterByYear';
import { getCommercialSalePricePerMeter } from './getCommercialSalePricePerMeter';
import { getVatTypeWithVatPrice } from './getVatTypeWithVatPrice';
import { isReadyBusiness } from './isReadyBusiness';
import { ECoworkingOfferType, IOffer } from '../../../types/offer';

const SEPARATOR = '・';

const COWORKING_WORKPLACE_TYPES: ReadonlySet<ECoworkingOfferType> = new Set([
  ECoworkingOfferType.Office,
  ECoworkingOfferType.FixedWorkplace,
  ECoworkingOfferType.FlexibleWorkplace,
]);

function isCoworkingWorkplace(offer: IOffer): boolean {
  return Boolean(offer.coworkingOfferType && COWORKING_WORKPLACE_TYPES.has(offer.coworkingOfferType));
}

export function getCommercialPriceSub(offer: IOffer, isNewTaxDisplayEnabled?: boolean): string | undefined {
  if (isReadyBusiness(offer)) {
    // Для готового и арендного бизнеса в подстроке показываем прибыль/мес., НДС не выводим
    return getCommercialIncomeTitle(offer);
  }

  const perMeter =
    offer.dealType === 'rent' ? getCommercialPerMeterByYear(offer) : getCommercialSalePricePerMeter(offer);
  const vat = isCoworkingWorkplace(offer) ? undefined : getVatTypeWithVatPrice(offer, isNewTaxDisplayEnabled);

  const parts = [perMeter, vat].filter(Boolean);

  return parts.length > 0 ? parts.join(SEPARATOR) : undefined;
}
